const tokens = {};
const theme = {
    meta: {
        scope: 'all',
        parameters: {
            backgroundColor: {
                type: 'string',
            },
            borderRadius: {
                type: 'number',
            },
            borderWidth: {
                type: 'number',
            },
            borderColor: {
                type: 'string',
            },
            shadowColor: {
                type: 'string',
            },
            shadowOffset: {
                type: 'object',
            },
            shadowOpacity: {
                type: 'number',
            },
            shadowRadius: {
                type: 'number',
            },
            minWidth: {
                type: 'number',
            },
            minHeight: {
                type: 'number',
            },
            flex: {
                type: 'number',
            },
            display: {
                type: 'string',
            },
            height: {
                type: 'number',
            },
        },
        appearances: {
            float: {
                default: true,
            },
            outline: {
                default: false,
            },
        },
        variantGroups: {
            interactive: {
                pressable: {
                    default: false,
                },
                pressableAlt: {
                    default: false,
                },
            },
        },
        states: {
            hover: {
                default: false,
                priority: 0,
                scope: 'all',
            },
            disabled: {
                default: false,
                priority: 1,
                scope: 'all',
            },
            active: {
                default: false,
                priority: 2,
                scope: 'all',
            },
            focused: {
                default: false,
                priority: 2,
                scope: 'mobile',
            },
        },
    },
    appearances: {
        float: {
            mapping: {
                display: 'flex',
                flex: 1,
                borderRadius: 'border-card-radius',
                shadowColor: '#000',
                shadowOffset: {
                    width: 0,
                    height: 2,
                },
                shadowOpacity: 0.23,
                shadowRadius: 2.62,
                backgroundColor: 'color-text-basic',
            },
            variantGroups: {
                interactive: {
                    pressable: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 4,
                                },
                                shadowOpacity: 0.30,
                                shadowRadius: 4.65,
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                    pressableAlt: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 4,
                                },
                                shadowOpacity: 0.30,
                                shadowRadius: 4.65,
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                },
            },
        },
        publisher: {
            mapping: {
                display: 'flex',
                flex: 1,
                borderRadius: 0,
                shadowColor: '#000',
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0.23,
                shadowRadius: 2.62,
                backgroundColor: 'color-text-basic',
            },
            variantGroups: {
                interactive: {
                    pressable: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 4,
                                },
                                shadowOpacity: 0.30,
                                shadowRadius: 4.65,
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                    pressableAlt: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 4,
                                },
                                shadowOpacity: 0.30,
                                shadowRadius: 4.65,
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                },
            },
        },
        flat: {
            mapping: {
                display: 'flex',
                flex: 1,
                borderRadius: 1,
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0,
                shadowRadius: 0,
                backgroundColor: 'color-text-basic',
            },
            variantGroups: {
                interactive: {
                    pressable: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 0,
                                },
                                shadowOpacity: 0,
                                shadowRadius: 0,
                                backgroundColor: 'color-brand-0',
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                    pressableAlt: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 0,
                                },
                                shadowOpacity: 0,
                                shadowRadius: 0,
                                backgroundColor: 'color-flat-200',
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                },
            },
        },
        outline: {
            mapping: {
                display: 'flex',
                flex: 1,
                borderRadius: 4,
                shadowOffset: {
                    width: 0,
                    height: 0,
                },
                shadowOpacity: 0,
                shadowRadius: 0,
                backgroundColor: 'color-text-basic',
                borderColor: 'color-flat-300',
                borderWidth: 1,
            },
            variantGroups: {
                interactive: {
                    pressable: {
                        state: {
                            hover: {
                                shadowOffset: {
                                    width: 0,
                                    height: 0,
                                },
                                shadowOpacity: 0,
                                shadowRadius: 0,
                                backgroundColor: 'color-flat-100',
                                borderColor: 'color-flat-400',
                            },
                            disabled: {},
                            active: {},
                            focused: {},
                        },
                    },
                },
            },
        },
    },
};
export default {
    tokens,
    theme,
};
//# sourceMappingURL=DNACard.theme.alucio.js.map